
import { Component, Prop, Vue } from "vue-property-decorator";
import { RehberVideolari } from "@/enum/RehberVideolari";

@Component
export default class RehberVideoButton extends Vue {
  // RehberVideolari içindeki anahtar (ör. "faizHesaplayici").
  @Prop({ type: String, default: "" }) readonly area!: string;
  // İstenirse doğrudan YouTube video id'si verilebilir (area yerine).
  @Prop({ type: String, default: "" }) readonly videoId!: string;
  @Prop({ type: String, default: "REHBER VİDEO" }) readonly label!: string;
  @Prop({ type: String, default: "primary" }) readonly color!: string;
  @Prop({ type: String, default: "mdi-video-outline" }) readonly icon!: string;
  // Dolgulu (solid) buton görünümü; varsayılan outlined.
  @Prop({ type: Boolean, default: false }) readonly filled!: boolean;
  @Prop({ type: Boolean, default: false }) readonly small!: boolean;
  @Prop({ type: Boolean, default: false }) readonly iconOnly!: boolean;

  get resolvedId(): string {
    if (this.videoId) {
      return this.videoId;
    }
    return (RehberVideolari as Record<string, string>)[this.area] || "";
  }

  get iconColor(): string {
    return this.filled ? "white" : this.color;
  }

  openVideo(): void {
    if (!this.resolvedId) {
      return;
    }
    window.open(`https://www.youtube.com/watch?v=${this.resolvedId}`, "_blank");
  }
}
